import axiosInstance from "../variables/api/axiosInstance";

export const profilsService = {
    /** Liste tous les profils actifs */
    list: () => axiosInstance.get('/v1/profils'),

    /** Détail d'un profil */
    get: (trackingId) => axiosInstance.get(`/v1/profils/${trackingId}`),

    /** Créer un profil */
    create: (data) => axiosInstance.post('/v1/profils', data),

    /** Modifier un profil */
    update: (trackingId, data) => axiosInstance.put(`/v1/profils/${trackingId}`, data),

    /** Suppression logique */
    delete: (trackingId) => axiosInstance.delete(`/v1/profils/${trackingId}`),

    /** Historique des versions d'un profil */
    history: (trackingId, page = 0, size = 20) =>
        axiosInstance.get(`/v1/profils/${trackingId}/historique`, {
            params: { page, size },
        }),
};